export const switchCase =
    <T>(object: Record<string, T>, defaultCase = '_default'): ((expression: string) => T) =>
    (expression: string): T =>
        object[expression] || object[defaultCase];
